
/**
 * Représente un bloc dans la toolbox,
 * avec son type (identifiant), et ses attributs
 * (deletable, updatable, etc.).
 */
export interface ToolboxBlock {
    type: string;
    movable: boolean;    // peut-on déplacer le bloc ?
    deletable: boolean;  // peut-on supprimer le bloc ?
    editable: boolean;   // peut-on éditer son contenu ?
    updatable: boolean;  // notion plus libre, selon votre usage
}

/**
 * Représente une catégorie dans la toolbox.
 * On conserve `name`, `color`, mais `blocks`
 * est désormais un tableau de ToolboxBlock.
 */
export interface ToolboxCategory {
    name: string;
    blocks: ToolboxBlock[];
    color: string;
}


export interface BlocklyConfig {
    // admin mode
    adminMode: boolean;
    workspace: string;
    // Workspace initial pour la vue enseignant
    teacherWorkspace?: string;

    // regrouper la toolbox par catégorie
    toolboxGrouped: boolean;

    // Configuration de la toolbox
    toolboxCategories: ToolboxCategory[];


}

export function getDefaultConfigWorkspace(adminMode: boolean = false): BlocklyConfig {
    return {
        adminMode: adminMode,
        workspace: '',
        teacherWorkspace: '',
        toolboxCategories: [],
        toolboxGrouped: false,
    }
}